import { render, staticRenderFns } from "./BackgroundThemeColor.vue?vue&type=template&id=08610e52&scoped=true"
import script from "./BackgroundThemeColor.vue?vue&type=script&lang=js"
export * from "./BackgroundThemeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08610e52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08610e52')) {
      api.createRecord('08610e52', component.options)
    } else {
      api.reload('08610e52', component.options)
    }
    module.hot.accept("./BackgroundThemeColor.vue?vue&type=template&id=08610e52&scoped=true", function () {
      api.rerender('08610e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/BackgroundThemeColor.vue"
export default component.exports